<div class="maintenance-mode">
  <div class="maintenance-content">
    <div class="image-container">
      <img
        src="/bg-overlays/extra-blurred-welding-bg.png"
        alt="Maintenance"
        class="maintenance-image"
        width="525"
        height="279"
      />
      <div class="working-text">Working on it...</div>
    </div>
    <h1 class="main-title">Sustainment is under maintenance</h1>
    <p class="description">
      We are sorry to inform you that our system is under
      <strong>maintenance</strong>.
    </p>
    <p class="contact">
      If you need assistance, please contact:
      <a href="mailto:support&#64;sustainment.com"
        >support&#64;sustainment.com</a
      >
    </p>
  </div>
</div>
